// 导入 抽取的 请求对象
import userRequest from '../utils/request';
const reFix = 'useradmin';

// 酒店宴会推荐 - 推荐报表
export function HotelBanquetApi(params) {
  return userRequest({
    url: reFix + '/HotelBanquet/pageList',
    method: 'post',
    // 跨域 是否携带 cookie
    withCredentials: true,
    data: params,
  });
}

// 酒店宴会推荐 - 登录日志
export function QueryHotelLoginLogApi(params) {
  return userRequest({
    url: reFix + '/HotelBanquet/QueryHotelLoginLog',
    method: 'post',
    // 跨域 是否携带 cookie
    withCredentials: true,
    data: params,
  });
}
